<template>
  <transition name="fade">
    <tr>
      <template v-if="course">
        <td class="td-white">
          <div class="dates-table__white dates-table__white--with-title">
            <img v-if="course.course_logo !== ''" :src="course.course_logo" />
            <span v-html="icon" />
            <strong>
              <a :href="course.url">{{ course.title }}</a>
            </strong>
          </div>
        </td>
        <td>
          <small>{{ $t("date") }}</small>
          <strong class="dates-table__value dates-table__value--bigger">
            {{ start | dayNumberInterval(duration) }}
            <small>{{ start | date }}</small>
            <br />
            <span>
              <small>
                {{ start | dayTextInterval(duration) }}
              </small>
            </span>
          </strong>
        </td>
      </template>
      <template v-else>
        <td>
          <div class="dates-table__white">
            <strong>
              {{ start | dayNumberInterval(duration) }}
            </strong>
            <span>
              <strong> {{ start | date }} </strong><br />
              {{ start | dayTextInterval(duration) }}
            </span>
          </div>
        </td>
      </template>
      <td v-if="event_type === 'both'">
        <small>{{ $t("city") }}</small>
        <strong class="dates-table__value dates-table__value--bigger">
          {{ city }}
          <small>
            {{ $t("or") }}
            <br />
            <a href="#info-modal" data-toggle="modal"
              >{{ $t("virtual_class") }}
              <sup><i class="far fa-info-circle"></i></sup>
            </a>
          </small>
        </strong>
      </td>
      <td v-else-if="event_type === 'virtual'">
        <small>{{ $t("city") }}</small>
        <a href="#info-modal" data-toggle="modal">
          {{ $t("virtual_class") }}
          <sup><i class="far fa-info-circle"></i></sup>
        </a>
      </td>
      <td v-else>
        <small>{{ $t("city") }}</small>
        <strong class="dates-table__value dates-table__value--bigger">
          {{ city }}
        </strong>
      </td>
      <td>
        <small>{{ $t("duration") }}</small>
        <strong class="dates-table__value dates-table__value--bigger">
          {{ duration }} {{ $tc("day", duration) }}
        </strong>
      </td>
      <td>
        <small>{{ $t("capacity") }}</small>
        <strong class="dates-table__value dates-table__value--bigger">
          {{ $t(`occupancy.${capacity}`) }}
        </strong>
      </td>
      <td>
        <small>{{ $t("language") }}</small>
        <strong class="dates-table__value dates-table__value--bigger">
          {{ $t(`language_translation.${language}`) }}
        </strong>
      </td>
      <td>
        <small>{{ $t("price_without_vat") }}</small>
        <strong
          class="dates-table__value dates-table__value--bigger dates-table__value--red"
        >
          <meta property="price" :content="price" />
          {{ price | currency }}
        </strong>
      </td>
      <td class="td-action">
        <a :href="orderLink" class="btn btn-danger">
          {{ $t("i_am_interested") }}
        </a>
      </td>
    </tr>
  </transition>
</template>

<script>
import { isContext } from "vm";

export default {
  name: "CourseEvent",
  props: [
    "course",
    "capacity",
    "city",
    "course_id",
    "duration",
    "id",
    "internal_number",
    "language",
    "event_type",
    "price",
    "price_with_certification",
    "price_before_discount",
    "price_before_discount_eu",
    "price_eu",
    "start",
    "trainers"
  ],
  computed: {
    orderLink() {
      if (this.$i18n.locale === "cs") return `/objednavka?event_id=${this.id}`;
      else return `/${this.$i18n.locale}/objednavka?event_id=${this.id}`;
    },
    repaymentsLink() {
      return `/objednavka?event_id=${this.id}&repayments=true`;
    },
    icon() {
      return this.course.course_icon.replace(
        "<i",
        `<i style="color: ${this.course.course_color}"`
      );
    }
  }
};
</script>

<i18n>
{
  "cs": {
    "capacity": "Obsazenost",
    "course": "Kurz",
    "day": "den | dny | dní",
    "date": "Datum kurzu",
    "duration": "Délka",
    "event_type": {
      "both": "Prezenčně nebo Virtuálně",
      "in_person": "Prezenčně",
      "virtual": "Online. Živě."
    },    
    "i_am_interested": "Mám zájem",
    "language": "Jazyk",
    "language_translation": {
      "cs": "Česky",
      "en": "Anglicky",
      "sk": "Slovensky"
    },
    "city": "Místo",
    "occupancy": {
      "X": "Obsazeno",
      "50% obsazenost": "50% obsazenost",
      "null":"Volno"
    },
    "or": "nebo",
    "price_without_vat": "Cena bez DPH",
    "repayments": "Chci kurz na splátky",
    "term": "Termín",
    "virtual_class": "Online. Živě"
  },
  "en": {
    "capacity": "Capacity",
    "course": "Course",
    "day": "day | days",
    "date": "Coursr Date",
    "duration": "Duration",
    "event_type": {
      "both": "Live (online) or Presence",
      "in_person": "Presence",
      "virtual": "Online. Live."
    },    
    "i_am_interested": "Book",
    "language": "Language",
    "language_translation": {
      "cs": "Czech",
      "en": "English",
      "sk": "Slovak"
    },
    "city": "Location",
    "occupancy": {
      "X": "Sold Out",
      "50% obsazenost": "50% occupancy",
      "null":"Free"
    },    
    "or": "or",
    "price_without_vat": "Price without VAT",
    "repayments": "I want installments",
    "term": "Date",
    "virtual_class": "Online. Live"
  },
  "sk": {
    "capacity": "Kapacita",
    "course": "Kurz",
    "day": "deň | dni",
    "date": "Dátum kurzu",
    "duration": "Dĺžka",
    "i_am_interested": "Objednať",
    "language": "Jazyk",
    "language_translation": {
      "cs": "Česky",
      "en": "English",
      "sk": "Slovensky"
    },
    "city": "Miesto",
    "occupancy": {
      "X": "Vypredané",
      "50% obsazenost": "50% obsadenosť",
      "null":"Voľný"
    },    
    "or": "or",
    "price_without_vat": "Cena bez DPH",
    "repayments": "I want installments",
    "term": "Dátum",
    "virtual_class": "Online. Naživo"
  }  
}
</i18n>
